module.exports = __webpack_public_path__ + "img/list_kargo.60ec8b2a.svg";